import { render, staticRenderFns } from "./BmCustomers.vue?vue&type=template&id=217ab1bc&"
import script from "./BmCustomers.vue?vue&type=script&lang=js&"
export * from "./BmCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports